<template>
  <table
    class="v-table v-data-table theme--light"
  >
    <thead>
      <tr>
        <th>
          <v-checkbox
            title="一括解除"
            :value="selectedIDs.length - customersArrayTopOffset > 0"
            :disabled="selectedIDs.length - customersArrayTopOffset === 0"
            color="success"
            class="unselect-checkbox"
            @change="initSelectedIDs"
          />
        </th>
        <th
          v-for="h in headers"
          :key="h.value"
        >
          {{ h.text }}
        </th>
      </tr>
    </thead>

    <tbody>
      <template v-if="loading">
        <td
          :colspan="headers.length + 2"
          class="text-xs-center"
        >
          <v-progress-circular
            class="mt-4 mb-2"
            indeterminate
            color="metalBlue"
            width="2"
          />
        </td>
      </template>

      <template
        v-for="(c, i) in searchResults"
        v-else-if="searchResults.length"
      >
        <tr
          :key="c.id"
          @click.stop="selectCustomer($event, c)"
        >
          <CheckBox
            :delivery-date="c.deliveryDate"
            :selected="selectedIDs.some(el => el === c.id)"
            @change="toggleSelectedIDs(c)"
          />
          <template v-for="h in headers">
            <td
              v-if="h.value === 'tank'"
              :key="h.value"
              class="tankCell"
            >
              <v-icon
                v-for="(tank,j) in c.tanks.filter((e,k)=>k<=3)"
                :key="j"
                :color="sensorState2Color[tank.sensorState]"
                :class="{'tankIcon' : j > 0 }"
              >
                mdi-flash-circle
              </v-icon>
              <span v-if="c.tanks.length>4">...</span>
            </td>
            <td
              v-else-if="h.value === 'volumeUpdatedAt' && c.hasSensorWarning"
              :key="h.value"
              :class="[h.cssClass]"
              style="color: red; font-weight: bold;"
            >
              {{ c[h.value] }}
            </td>
            <td
              v-else
              :key="h.value"
              :class="[
                h.cssClass,
                h.type === 'colored' ? 'pl-1 pr-1' : '',
                h.type === 'multi' && typeof c[h.value] === 'number' ? 'strong' : ''
              ]"
            >
              <div
                v-if="h.type === 'colored'"
                :style="c[h.value].style"
              >
                {{ c[h.value].label }}
              </div>
              <template v-else>
                {{ c[h.value] }}
              </template>
            </td>
          </template>
          <SpeechBubble
            v-if="speechBubbleContent[i].length && searchText === ''"
            :speech-bubble-content="speechBubbleContent[i]"
            @click="speechBubbleClickHandler(i)"
          />
        </tr>
      </template>

      <template
        v-else
      >
        <td
          :colspan="headers.length + 2"
          class="text-xs-center"
        >
          <p class="mt-4 mb-2">
            顧客が見つかりませんでした。
          </p>
        </td>
      </template>
    </tbody>
  </table>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { CheckBox, SpeechBubble } from './DeliveryTable/index'

export default {
  components: {
    CheckBox,
    SpeechBubble
  },
  props: {
    detailId: {
      type: Number,
      default: () => null
    }
  },
  data () {
    return {
      selectedCustomerId: null,
      selectedTankId: null,
      selectedElem: null
    }
  },
  computed: {
    ...mapState('list', ['headers', 'customers', 'searchResults', 'selectedIDs', 'loading', 'searchText', 'sensorState2Color']),
    ...mapGetters('list', ['customersArrayTopOffset', 'speechBubbleContent'])
  },
  watch: {
    detailId (val) {
      if (val) return
      this.selectedElem.classList.remove('active')
      this.selectedElem = null
    },
    loading (val) {
      if (val) this.$emit('select-customer', null)
    }
  },
  methods: {
    ...mapActions('list', ['initSelectedIDs', 'toggleSelectedIDs']),
    selectCustomer ({ currentTarget }, customer) {
      if (this.detailId === customer.id) {
        this.$emit('select-customer', null)
        return
      }
      if (this.selectedElem) {
        this.selectedElem.classList.remove('active')
      }
      currentTarget.classList.add('active')
      this.selectedElem = currentTarget
      this.$emit('select-customer', customer)
    },
    speechBubbleClickHandler (i) {
      if (i <= this.customersArrayTopOffset - 1) { return }

      this.initSelectedIDs()
      for (let j = 0; j <= i; j++) {
        if (!this.customers[j].deliveryDate.date) {
          this.toggleSelectedIDs(this.customers[j])
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.strong {
  font-weight: bold;
  font-size: 110%;
}
.active {
  background-color: #b3d4fc !important; // tab
}
.menu-arrow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.tankIcon{
  margin-left: -10px;
  filter: drop-shadow(0px 0px 1px white);
}
.tankCell{
  width: 100px;
  text-align: center;
}
/deep/.unselect-checkbox {
  .theme--light.v-messages {
    display: none;
  }
  .v-input__slot{
    margin-bottom: 0px !important;
  }
}
.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
</style>
